import { AfterViewInit, Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { App, NavController, NavParams } from 'ionic-angular';
import { HttpErrorResponse } from '../../../node_modules/@angular/common/http';
import { Storage } from '../../../node_modules/@ionic/storage';
import { TranslateService } from '../../../node_modules/@ngx-translate/core';
import { ModalDirective } from '../../../node_modules/ngx-bootstrap';
import { Observable } from '../../../node_modules/rxjs';
import { AlertsHolder } from '../../app/models/AlertsHolder';
import { Customer } from '../../app/models/Customer';
import { CustomerGroup } from '../../app/models/CustomerGroup';
import { TableDirective } from '../../directives/table-directive';
import { NavControllerService } from '../../providers/nav-controller/navControllerService';
import { GetCustomersType, PaytronBackendService } from '../../providers/paytron-backend/paytron-backend.service';
import { Utils } from '../../providers/paytron-backend/utils';

@Component({
  selector: 'page-customer-group-details',
  templateUrl: 'customer-group-details.html',
})
export class CustomerGroupDetailsPage implements AfterViewInit, OnDestroy, OnInit {
  @ViewChild(TableDirective)
  private table: TableDirective;

  @ViewChild('autocomplete')
  autocomplete: ElementRef;

  @ViewChild('inputGroupName')
  inputGroupName: ElementRef;

  @ViewChild('deleteModal')
  private confirmModal: ModalDirective;

  private pageName: string = 'page-customer-group-details';
  private currentCustomerGroup: CustomerGroup;
  private currentCustomer: Customer;
  private currentCustomerIndex: number;
  private owner: Customer;
  private customers: Customer[];
  private selected: string;
  private datasource: any[];

  private alertsHolder: AlertsHolder;
  private disableBlur = false;

  private navControllerService: NavControllerService;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private utils: Utils,
    private backendService: PaytronBackendService,
    private app: App,
    private translate: TranslateService,
    private storage: Storage
  ) {
    this.navControllerService = new NavControllerService(app, storage);
    this.currentCustomerGroup = new CustomerGroup();
    let currentCustomerGroupUuid: string = this.navParams.get('customerGroupUuid');
    this.customers = [];
    if (currentCustomerGroupUuid) {
      this.loadCurrentCustomerGroup(currentCustomerGroupUuid);
    }

    this.datasource = [];
    this.alertsHolder = new AlertsHolder(translate);
  }

  private loadCurrentCustomerGroup(currentCustomerGroupUuid: string) {
    this.backendService.getCustomerGroup(currentCustomerGroupUuid).subscribe(
      (data: CustomerGroup) => {
        this.currentCustomerGroup = data;
        this.owner = this.currentCustomerGroup.owner;
        this.getCustomers();
      },
      (err: HttpErrorResponse) => {}
    );
  }

  ngOnInit(): void {
    let __this = this;
    this.table.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 10,
      drawCallback: () => {
        if (__this.currentCustomerGroup.uuid) {
          __this.autocomplete.nativeElement.focus();
        } else {
          __this.inputGroupName.nativeElement.focus();
        }
        this.disableBlur = false;
      },
    };
  }
  ngAfterViewInit(): void {}
  ngOnDestroy(): void {}

  private getCustomers() {
    let customerList: Observable<Customer[]> = this.backendService.getCustomers();
    let alreadyTakenIds = this.currentCustomerGroup.customers.map((value) => {
      return value.uuid;
    });
    customerList.subscribe((values ) => {
      this.customers = values.filter((customer) => {
        return alreadyTakenIds.indexOf(customer.uuid) == -1;
      });

      this.datasource = this.customers.map((customer) => {
        this.utils.reformatAllAccountsOwnerInputDateStrings(customer);
        return { id: customer.uuid, name: customer.firstName + ' ' + customer.lastName + ' ' + customer.dateOfBirth };
      });
      this.table.refreshTable();
    });
  }

  onSelect(event) {
    this.selected = '';
    let response = this.backendService.getCustomer(event.item.id);
    response.subscribe(
      (data) => {
        this.currentCustomerGroup.customers.push(data);
        this.submitCustomerGroup();
      },
      (err: HttpErrorResponse) => {}
    );
  }

  onBlur() {
    if (this.currentCustomerGroup.name.trim().length != 0 && this.disableBlur == false) {
      this.submitCustomerGroup();
    }
  }

  onEnter() {
    if (this.currentCustomerGroup.name.trim().length != 0) {
      this.disableBlur = true;
      this.submitCustomerGroup();
    }
  }

  setOwner(customer) {
    this.currentCustomerGroup.owner = customer;
    this.owner = customer;
    this.submitCustomerGroup();
  }

  submitCustomerGroup() {
    let response = this.backendService.saveOrUpdateCustomerGroup(this.currentCustomerGroup);

    response.subscribe(
      (data) => {
        this.currentCustomerGroup = data;
        this.owner = this.currentCustomerGroup.owner;
        this.table.refreshTable();
        this.getCustomers();
        this.alertsHolder.show('Customer Group successfully saved', 'success');
      },
      (err: HttpErrorResponse) => {}
    );
  }

  removeCustomer() {
    if (this.isCurrentCustomerOwner()) {
      this.owner = null;
      this.currentCustomerGroup.owner = null;
    }
    this.currentCustomerGroup.customers.splice(this.currentCustomerIndex, 1);
    this.submitCustomerGroup();
    this.table.refreshTable();
    this.closeConfirmModal();
  }

  private isCurrentCustomerOwner(): boolean {
    if (!this.owner) {
      return false;
    } else {
      return this.currentCustomer.uuid == this.owner.uuid;
    }
  }

  showConfirmModal(customer, index) {
    this.currentCustomer = customer;
    this.currentCustomerIndex = index;
    this.confirmModal.show();
  }

  closeConfirmModal() {
    this.confirmModal.hide();
  }

  showCustomerGroups() {
    this.navControllerService.showCustomerGroupPage();
  }

  showCustomerDetailsPage(customer) {
    this.navControllerService.showCustomerDetailsPage(customer);
  }
}



// WEBPACK FOOTER //
// ./src/pages/customer-group-details/customer-group-details.ts